import styled from 'styled-components'
import { FeaturesStyle } from '../../Features/FeaturesStyle'
/**
 * Styled component is used to decorate CardWrapper component.
 * Props are passed from ThemeProvider component.
 */

export const BasketCardStyle = styled.div`
  background-color: ${(props) =>
    props.theme.card?.backgroundColor ||
    props.theme.colors?.background ||
    '#D8D2E8'};
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 1em 24px 1em;
  align-items: center;
  border: ${(props) => props.theme.card?.border || 'solid 2px'};
  border-color: ${(props) => props.theme.card?.borderColor || '#000000'};
  border-radius: ${(props) => props.theme.card?.borderRadius || '1.5em'};
  max-width: 100%;
  color: ${(props) =>
    props.theme.card?.color || props.theme.colors?.primary || '#000000'};

  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  margin: 0em 1em 1em 1em;
  font-size: 0.8em;

  ${FeaturesStyle} {
    flex-grow: 1;
  }
`

export const BasketCardWrapper = styled.div`
  display: flex;
  color: ${(props) =>
    props.theme.card?.color || props.theme.colors?.primary || '#000000'};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1em 0;
  margin: 1em 0;
  border: 1px solid black;
  max-width: 50em;
`

export const BasketCardRow = styled.div`
  display: flex;
  width: 100%;
`
